import { Divider, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import PinIcon from '@material-ui/icons/Apps';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import CardIcon from '@material-ui/icons/CreditCard';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
import LockIcon from '@material-ui/icons/LockOpen';
import UserIcon from '@material-ui/icons/PersonOutline';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE, CARD_TYPES, CREDENTIAL_RULE_STATUSES, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../_config/consts';
import { isUserWithoutEmail } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import * as UtilActions from '../../redux/actions/utils.actions.js';
import PrivateUnitsIconCustom from '../CustomIcons/PrivateUnitsIconCustom.jsx';
import Tag from '../Tag.jsx';
import CalendarClockIconCustom from '../CustomIcons/CalendarClockIconCustom.jsx';

const styles = {
  circularProgress: {
    color: BLUE,
  },
  buttonPU: {
    color: BLUE,
    fontSize: 12,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  hoverMenu: {
    position: 'absolute',
    right: -17,
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'white',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0',
    zIndex: 1000,
  },
  menuButton: {
    padding: 10,
    paddingLeft: 13,
    paddingRight: 13,
    margin: '2px 0',
  },
};
@connect((state) => ({ settings: state.settings, companyConfigurations: state.user.companyConfigurations, }))
class CardDetailsRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: props.onClick ? false : undefined,
    };
  }

  onHandleMouseEnter = () => {
    this.setState({ isHovered: true });
  }

  onHandleMouseLeave = () => {
    this.setState({ isHovered: false });
  }

  onHandleDelete() {
    const { onDeleteCardRequest, card } = this.props;
    if (onDeleteCardRequest) {
      onDeleteCardRequest(card);
    }
  }

  onHandleCopy () {
    const { onCreateCardCredentialFromModel, card } = this.props;
    if (onCreateCardCredentialFromModel) {
      onCreateCardCredentialFromModel(card);
    }
  }

  render() {
    const { card, privateUnits, onOpenPrivateUnitRequest, onClick, isSelected, classes, companyConfigurations, dispatch, hideHeader } = this.props;
    const { isHovered } = this.state;
    const privateUnitId = card.privateUnitId
    const privateUnit = privateUnitId && privateUnits.find(e=>e.id===privateUnitId) || undefined
    const user = card.user;
    const isSuperError = _.isEmpty(card.credentialRule.lockTags) || !user;
    const isLoadingState = !card.credentialRule.state;
    let statusColor = card.credentialRule.state !== CREDENTIAL_RULE_STATUSES.NOT_UPDATED ? '#43A047' : '#EF6C00';
    statusColor = isSuperError ? 'red' : statusColor;
    statusColor = isLoadingState ? 'gray' : statusColor;

    const isUserDeleted = card && card.user && card.user.email && !_.includes(card.user.email, '@');

    let statusLabel = card.credentialRule.state === CREDENTIAL_RULE_STATUSES.NOT_UPDATED ? 'notUpdated' : 'updated';
    statusLabel = card.deleted ? 'cardDeleting' : statusLabel;
    statusLabel = isSuperError ? 'credentialRuleInvalid' : statusLabel;
    statusLabel = isLoadingState ? 'loading' : statusLabel;

    const { credentialRule: credential } = card;
    const days = credential && credential.daysOfTheWeek && _.orderBy(credential.daysOfTheWeek);
    const daysOptions = _.map(moment.weekdays(true), weekday => ({
      label: moment.weekdaysMin(moment().isoWeekday(weekday).isoWeekday()),
      selected: _.indexOf(days, moment().isoWeekday(weekday).isoWeekday()) !== -1,
    }));

    const additionalDays = credential.additionalTimeRange && credential.additionalTimeRange.daysOfTheWeek && _.orderBy(credential.additionalTimeRange.daysOfTheWeek);
    const additionalDaysOptions = _.map(moment.weekdays(true), weekday => ({
      label: moment.weekdaysMin(moment().isoWeekday(weekday).isoWeekday()),
      selected: _.indexOf(additionalDays, moment().isoWeekday(weekday).isoWeekday()) !== -1,
    }));
    const isInvalidNoTags = _.isEmpty(credential.lockTags) || _.isEmpty(credential.guestTags);
    statusLabel = isInvalidNoTags ? 'credentialRuleInvalid' : statusLabel;
    statusColor = isInvalidNoTags ? 'red' : statusColor;

    const isCardMappingEnabled = companyConfigurations && companyConfigurations.customCardsMapping && companyConfigurations.customCardsMapping.enabled;
    const cardIdsMap = companyConfigurations && companyConfigurations.customCardsMapping && companyConfigurations.customCardsMapping.cardIdsMap ? companyConfigurations.customCardsMapping.cardIdsMap : [];

    const originalCard = isCardMappingEnabled ? _.find(cardIdsMap, cardToTranslate => cardToTranslate.luckeyCardId === card.deviceId) : null;
    const validityDateFormat = dispatch(UtilActions.getCredentialValidityDateFormat());

    const canDeleteCard = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canCreateNewCard = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.CREATE], PERMISSION_ENTITIES.STANDARD_DEVICE);

    return (
      <div 
        style={{ position: 'relative', marginBottom: 20 }}
        onMouseEnter={onClick ? this.onHandleMouseEnter : undefined}
        onMouseLeave={onClick ? this.onHandleMouseLeave : undefined}
      >
        <Card
          className={`card card-rounded ${(!onClick || privateUnitId) && 'card-noHover'} ${isSelected && 'card-selected'}`}
          style={{ borderRadius: 10, borderLeft: `4px solid ${statusColor}`, padding: 0, opacity: isSuperError || isInvalidNoTags || !card.credentialRule.state ? 0.5 : 1 }}
          onClick={onClick && !privateUnitId ? onClick : undefined}
          elevation={2}
        >
        {hideHeader ? null : (
        <div className="card-header access-card-header" style={{ paddingRight: 10, alignItems: 'center', display: 'flex', justifyContent: 'space-between', marginTop: 10, position: 'relative' }}>
          <div>
            <div style={{ display: 'flex' }}>
              {originalCard && originalCard.originalId ? (
                <h2 style={{ flex: 1, fontSize: 20, fontWeight: 'bold', marginRight: -10, marginLeft: 15, marginTop: 0, marginBottom: 0, color: '#3f3f3f' }}>
                  {`${originalCard && originalCard.originalId} -`}
                </h2>
              ) : null}
              <h2 style={{ flex: 1, fontSize: 24, fontWeight: 'bold', marginLeft: 15, marginTop: 0, marginBottom: 0, color: '#3f3f3f' }}>
                {`#${card.deviceId}`}
              </h2>
            </div>
            {card.notes && (
              <div style={{ marginLeft: 17, marginRight: 15, marginTop: 10 }}>
                <h5 style={{ margin: 0, marginTop: 2, wordBreak: 'break-word', color: '#3f3f3f', fontWeight: 'normal' }}>
                  {card.notes}
                </h5>
              </div>
            )}
          </div>
          <div>
            {isLoadingState && <CircularProgress size={16} className={classes.circularProgress} style={{ color: 'gray', position: 'absolute', right: 120, top: 10 }} />}
            <h6 style={{ color: 'red', margin: 10, fontSize: 13, fontWeight: 'bold', marginTop: 0, textAlign: 'right', position: 'absolute', right: 0, top: 10 }}>
              <Entity
                key={`status_${card.credentialRule.state}`}
                style={{ textTransform: 'uppercase', color: statusColor }}
                entity={statusLabel}
              />
            </h6>
          </div>
        </div>)}
        {!hideHeader ? <div className="separator" style={{ marginTop: 10 }} /> : <div style={{ marginTop: 10 }} />}
        <div className="card-body" style={{ paddingBottom: 10, position: 'relative' }}>
          <div className="card-inner-body" >
          <div style={{ marginTop: 7, display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'flex-start', marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
              <CalendarClockIconCustom style={{ color: '#3f3f3f', width: 20 }} />
              <h4 style={{ margin: 0, fontSize: 16, color: '#3f3f3f', fontWeight: 'bold', marginLeft: 5 }}>
                <Entity entity="credentialDateInterval" />
              </h4>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                {`${moment(credential.dateInterval.from).format(validityDateFormat)} - ${moment(credential.dateInterval.to).format(validityDateFormat)}`}
              </h5>
              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 7 }}>{` | ${moment(credential.timeIntervalFrom).format('LT')} - ${moment(credential.timeIntervalTo).format('LT')}`}</h5>
              {credential.additionalTimeRange ? (
                <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 7 }}>{` | ${moment(credential.additionalTimeRange.timeIntervalFrom).format('LT')} - ${moment(credential.additionalTimeRange.timeIntervalTo).format('LT')}`}</h5>
              ) : null}
            </div>
            <div style={{ marginTop: 10, display: 'flex' }}>
              {_.map(daysOptions, option => (
                <h5 key={option.label} style={{ margin: 0, marginRight: 7, color: option.selected ? '#3f3f3f' : 'gray', fontWeight: option.selected ? 'bold' : 'normal' }}>
                  {option.label.toUpperCase()}
                </h5>
                ))}
                {credential.additionalTimeRange ? (
                  <>
                  <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>{'| '}</h5>
                    {_.map(additionalDaysOptions, option => (
                      <h5 key={option.label} style={{ margin: 0, marginRight: 5, color: option.selected ? '#3f3f3f' : 'gray', fontWeight: option.selected ? 'bold' : 'normal' }}>
                        {option.label.toUpperCase()}
                      </h5>
                    ))}
                </>
                ) : null}
            </div>
            {credential.openOnPrivacy ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
                <CheckCircleOutline style={{ fontSize: 14, color: '#3f3f3f' }} />
                <h5 style={{ color: '#3f3f3f', margin: 0, marginLeft: 5 }}>
                  <Entity entity="privacyOverride" />
                </h5>
              </div>
            ) : null}
            {credential.alwaysOpen ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 7 }}>
                <CheckCircleOutline style={{ fontSize: 14, color: '#3f3f3f' }} />
                <h5 style={{ color: '#3f3f3f', margin: 0, marginLeft: 5 }}>
                  <Entity entity="togglePassageMode" />
                </h5>
              </div>
            ) : null}
          </div>
          <Divider style={{ marginTop: 0, marginBottom: 5, marginRight: 10 }} />
            {user ?
              <div className="card-tag-presentational-container" style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <UserIcon style={{ color: '#3f3f3f', fontSize: 22 }} />
                  <h4 style={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold', marginLeft: 5 }}>
                    <Entity entity="authorizedUser" />
                  </h4>
                </div>
                <div className="access-card-user-container" style={{ width: '90%' }}>
                  {privateUnitId ? (
                    <h5 style={{ margin: 5, fontWeight: 'bold', color: '#3f3f3f' }}>
                      {!isUserDeleted ? `[PU] ${(privateUnit && privateUnit.name) || ""} - ${L20NContext.getSync('guest')} ${card.user.id}` : <Entity entity="userDeleted" />}
                    </h5>
                  ):null}
                  {privateUnit ? (
                    <Button
                      onClick={(event) => {
                        event.stopPropagation();
                        onOpenPrivateUnitRequest(privateUnitId);
                      }}
                      className={classes.buttonPU}
                    >
                      {`${L20NContext.getSync('openPrivateUnit')}`}
                      <PrivateUnitsIconCustom style={{ width: 20, marginLeft: 5 }} />
                    </Button>
                  ):null}
                  {!privateUnit && card && card.user && (
                    <h5 style={{ margin: 5, fontWeight: 'bold', color: '#3f3f3f' }}>
                      {!isUserDeleted ? `${card.user.firstname} ${card.user.lastname} ${isUserWithoutEmail(card.user) ? '': ` - ${card.user.email}`}` : <Entity entity="userDeleted" />}
                    </h5>
                  )}
                  {!privateUnitId && card && card.credentialRule && !_.isEmpty(card.credentialRule.guestTags) &&
                    <div className="tags-container" style={{ marginTop: 0, marginBottom: 0 }}>
                      {_.map(card.credentialRule.guestTags, tag =>
                        <Tag
                          key={tag.id}
                          tag={tag}
                        />,
                      )}
                    </div>
                  }
                </div>
              </div> :
              <div>
                <h4 className="card-title"><Entity entity="unassignedCard" /></h4>
              </div>
            }
            
            {!privateUnitId && card && card.credentialRule && !_.isEmpty(card.credentialRule.lockTags) &&
              <div className="card-tag-presentational-container" style={{ marginTop: 15 }}>
              <Divider style={{ marginTop: 0, marginBottom: 15, marginRight: 10 }} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LockIcon style={{ color: '#3f3f3f', fontSize: 22, marginRight: 5 }} />
                  <h4 style={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold', margin: 0, marginLeft: 5 }}>
                    <Entity entity="selectedLocks" />
                  </h4>
                </div>
                <div className="tags-container">
                  {_.map(card.credentialRule.lockTags, tag =>
                    <Tag
                      key={tag.id}
                      tag={tag}
                    />)}
                </div>
              </div>
            }
          </div>
        {card.credentialRule && (
          <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
            <div className="credential-status-triangle-container" style={{ borderColor: `transparent transparent ${statusColor} transparent` }}>
              {card.type === CARD_TYPES.ISEO_PIN ?
               (
                <PinIcon style={{ color: 'white', position: 'absolute', fontSize: 18, bottom: 10, right: 10 }} />
               ) :
              (
                <CardIcon style={{ color: 'white', position: 'absolute', fontSize: 18, bottom: 10, right: 10 }} />
              )
              }
            </div>
          </div>
        )}
        </div>
      </Card>
      {onClick && isHovered && !card.privateUnitId && (canCreateNewCard || canDeleteCard) && (
        <div className={classes.hoverMenu}>
        {canCreateNewCard ? (
          <IconButton 
            className={classes.menuButton}
              onClick={(event) => {
                event.stopPropagation();
                this.onHandleCopy();
              }}
              size="small"
              aria-label="copy"
            >
              <FileCopyIcon style={{ fontSize: 20, color: BLUE }} />
            </IconButton>
          ) : null}
          {canDeleteCard ? (
            <IconButton 
              className={classes.menuButton}
              onClick={(event) => {
                event.stopPropagation();
                this.onHandleDelete();
              }}
              size="small"
              aria-label="delete"
            >
              <DeleteIcon style={{ fontSize: 20, color: RED }} />
            </IconButton>
          ) : null}
        </div>
      )}
      </div>
    );
  }
}

export default withStyles(styles)(CardDetailsRow);
